export default __webpack_public_path__ + "static/media/step4.1cc19bc1.svg";